import { RouteItem } from '@app/Routes';
import { FC } from 'react';
import styles from './project-pages-list.module.scss';
import { ProjectMenuItem } from '@app/modules/projects/project-pages-list/project-menu-item/ProjectMenuItem';

export const PARENT_CLASSNAME = 'project-pages-list';

interface ProjectPagesListProps {
  routes: RouteItem[];
  className?: string;
  subtitle?: string;
  indented?: boolean;
}

const ProjectPagesList: FC<ProjectPagesListProps> = ({
  routes,
  subtitle,
  className,
  indented,
}): JSX.Element => {
  return (
    <div className={`${styles[PARENT_CLASSNAME]} ${className}`}>
      <ul className={`${styles[`${PARENT_CLASSNAME}__list`]}`}>
        {subtitle && <div className={styles[`${PARENT_CLASSNAME}__subtitle`]}>{subtitle}</div>}
        {routes.map((link: RouteItem) => (
          <li
            key={link.title}
            className={`${styles[`${PARENT_CLASSNAME}__list-item`]} ${
              indented && styles[`${PARENT_CLASSNAME}__indented`]
            }`}>
            <ProjectMenuItem route={link.route} title={link.title} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectPagesList;
